export default "__VITE_ASSET__9782634a__"